import {
  AssignUserRolePayload,
  PrincipalInvestigator,
  StudyCordinator,
  UserRoleDefinition,
  UserListItem,
} from "@/types/user.type";
import { TherapeuticArea } from "@/types/therapeutic-area.type";
import type { IUserRepository } from "../repositories/UserRepository";

export interface IUserUseCase {
  getUsers(): Promise<UserListItem[]>;
  getUserRoles(): Promise<UserRoleDefinition[]>;
  assignRolesToUser(
    userId: string,
    payload: AssignUserRolePayload,
  ): Promise<void>;
  getPrincipalInvestigators(): Promise<PrincipalInvestigator[]>;
  getStudyCordinators(): Promise<StudyCordinator[]>;
  getTherapeuticAreas(): Promise<TherapeuticArea[]>;
}

export class UserUseCase implements IUserUseCase {
  constructor(private readonly userRepository: IUserRepository) {}

  async getUsers(): Promise<UserListItem[]> {
    return await this.userRepository.getUsers();
  }

  async getUserRoles(): Promise<UserRoleDefinition[]> {
    return await this.userRepository.getUserRoles();
  }

  async assignRolesToUser(
    userId: string,
    payload: AssignUserRolePayload,
  ): Promise<void> {
    return await this.userRepository.assignRolesToUser(userId, payload);
  }

  async getPrincipalInvestigators(): Promise<PrincipalInvestigator[]> {
    return await this.userRepository.getPrincipalInvestigators();
  }

  async getStudyCordinators(): Promise<StudyCordinator[]> {
    return await this.userRepository.getStudyCordinators();
  }

  async getTherapeuticAreas(): Promise<TherapeuticArea[]> {
    return await this.userRepository.getTherapeuticAreas();
  }
}
